import React from "react";
import EmployeeGenericSkeleton from "./EmployeeGenericSkeleton";

function EmployeeDetailSkeleton() {
  return (
    <>
      <EmployeeGenericSkeleton />
    </>
  );
}

export default EmployeeDetailSkeleton;
